import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "mt-4 mb-5 border-gray p-3 rounded-3-half"
};
var _hoisted_2 = {
  "class": "d-flex align-items-center gap-2 mb-1"
};
var _hoisted_3 = {
  "class": "d-flex flex-md-row flex-column gap-2 mt-3"
};
var _hoisted_4 = ["value"];
var _hoisted_5 = ["disabled"];
export default {
  __name: 'ProductExpansionSearchPanel',
  props: {
    query: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      "default": false
    }
  },
  emits: ['update:query', 'submit'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    function onInput(event) {
      emit('update:query', event.target.value);
    }
    function onSubmit() {
      emit('submit');
    }
    return function (_ctx, _cache) {
      var _component_BTooltip = _resolveComponent("BTooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("form", {
        "class": "m-1 d-flex flex-column",
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("h5", {
        "class": "font-size-14 font-weight-semibold mb-0 font-family-open-sans"
      }, "AI-Powered Product Expansion Ideas", -1)), _createVNode(_component_BTooltip, {
        "class": "sh-tooltip-light-sm",
        placement: "bottom"
      }, {
        target: _withCtx(function () {
          return _cache[0] || (_cache[0] = [_createElementVNode("span", {
            "class": "badge rounded-pill text-bg-primary font-size-9 font-weight-medium lh-1"
          }, [_createElementVNode("span", {
            "class": "pe-none"
          }, "BETA")], -1)]);
        }),
        "default": _withCtx(function () {
          return [_cache[1] || (_cache[1] = _createTextVNode(" This feature is in beta. Results may vary as we refine accuracy and performance. "))];
        }, undefined, true),
        _: 1
      })]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        "class": "opacity-75 font-size-12"
      }, "Enter your current product to get personalized expansion suggestions", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("input", {
        "class": "form-control font-size-12 border-0 rounded-2 py-2 form-search-product flex-grow-1",
        type: "search",
        placeholder: "e.g., Laptop Stand, Wireless Charger, Fitness Tracker...",
        value: __props.query,
        onInput: onInput
      }, null, 40, _hoisted_4), _createElementVNode("button", {
        type: "submit",
        "class": "btn btn-dark-blue btn-sm d-flex align-items-center font-size-11 gap-1 justify-content-center rounded-2 text-nowrap px-5",
        disabled: __props.isLoading || !__props.query.trim()
      }, [_cache[3] || (_cache[3] = _createElementVNode("img", {
        src: "/img/v5/db_ic_sparks.svg"
      }, null, -1)), _createTextVNode(" " + _toDisplayString(__props.isLoading ? 'Generating ideas...' : 'Generate expansion ideas'), 1)], 8, _hoisted_5)])], 32)]);
    };
  }
};